import { render, staticRenderFns } from "./classOpenServiceTwo3.vue?vue&type=template&id=23313ff1&scoped=true&"
import script from "./classOpenServiceTwo3.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceTwo3.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceTwo3.vue?vue&type=style&index=0&id=23313ff1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23313ff1",
  null
  
)

export default component.exports